import { makeAsyncActionTypes } from 'uf/data/ActionTypes';

export const forwardGecodeActionTypes = makeAsyncActionTypes(
  'uf/mapi/forwardGeocode',
);

export const SELECT_FEATURE = 'uf/mapi/forwardGeocode/SELECT_FEATURE';
